import { useMutationState } from "@tanstack/react-query";
import { saveKey } from "../../api/inspections";

function hhmm(at: number): string {
  const d = new Date(at);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** What became of the last write to this inspection, from any section:
 * saving, saved at a time, or not saved. It speaks only of writes made on
 * this screen; a section with its own Save button still needs pressing. */
export default function SaveState({ inspectionId }: { inspectionId: number }) {
  const writes = useMutationState({
    filters: { mutationKey: saveKey(inspectionId) },
    select: (m) => ({ status: m.state.status, at: m.state.submittedAt }),
  });
  const last = writes.reduce<(typeof writes)[number] | null>((latest, w) => (latest === null || w.at >= latest.at ? w : latest), null);
  if (last === null) {
    return null;
  }
  if (last.status === "pending") {
    return <span className="insp-save">Saving…</span>;
  }
  if (last.status === "error") {
    return <span className="insp-save bad">Not saved</span>;
  }
  return <span className="insp-save ok">Saved {hhmm(last.at)}</span>;
}
